import { Calendar, MapPin, Send, Shirt, Wallet } from '@/components/icons'
import { useKeyboardVisibility } from '../hooks/useKeyboardVisibility'
import { cn } from '../utils/cn'
import { NavigationItem } from './NavigationItem'

interface NavigationProps {
  currentSection: string
}

const NAV_ITEMS = [
  { id: 'schedule', label: 'スケジュール', icon: Calendar },
  { id: 'access', label: 'アクセス', icon: MapPin },
  { id: 'dresscode', label: 'ドレスコード', icon: Shirt },
  { id: 'fee', label: '参加費', icon: Wallet },
  { id: 'rsvp', label: '出欠', icon: Send },
] as const

export default function Navigation({ currentSection }: NavigationProps) {
  const isKeyboardVisible = useKeyboardVisibility()

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return (
    <>
      {/* デスクトップ用ナビゲーション（上部） */}
      <nav className="hidden md:block fixed top-0 left-0 right-0 z-40 bg-white/90 backdrop-blur-md shadow-lg">
        <div className="container mx-auto px-4">
          <div className="flex justify-center items-center h-16">
            <div className="flex gap-8">
              {NAV_ITEMS.map((item) => (
                <NavigationItem
                  key={item.id}
                  {...item}
                  isActive={currentSection === item.id}
                  onClick={scrollToSection}
                  variant="desktop"
                />
              ))}
            </div>
          </div>
        </div>
      </nav>

      {/* モバイル用ナビゲーション（下部） */}
      <nav className={cn(
        "md:hidden fixed bottom-0 left-0 right-0 z-40 bg-white/90 backdrop-blur-md shadow-lg border-t-2 border-pastel-purple/20 transition-transform duration-300",
        isKeyboardVisible && "translate-y-full"
      )}>
        <div className="flex justify-between items-center h-20">
          {NAV_ITEMS.map((item) => (
            <NavigationItem
              key={item.id}
              {...item}
              isActive={currentSection === item.id}
              onClick={scrollToSection}
              variant="mobile"
            />
          ))}
        </div>
      </nav>
    </>
  )
}
